import { render, staticRenderFns } from "./UserEditBtn.vue?vue&type=template&id=b2882fa0&"
import script from "./UserEditBtn.vue?vue&type=script&lang=ts&"
export * from "./UserEditBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports